export default "__VITE_ASSET__CejDn7rK__"